import { render } from "./AgencyApiModelHistory.vue?vue&type=template&id=0892466b"
import script from "./AgencyApiModelHistory.vue?vue&type=script&lang=js"
export * from "./AgencyApiModelHistory.vue?vue&type=script&lang=js"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__